import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function FuelIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M6.18 3A2.24 2.24 0 0 0 4 5.25v23.63C4 29.5 4.49 30 5.1 30h13.08c.6 0 1.1-.5 1.1-1.13v-5.06c0-.3.24-.56.54-.56h.54c.62 0 1.1.49 1.1 1.13v1.12a3.34 3.34 0 0 0 3.27 3.38c1.8 0 3.27-1.53 3.27-3.38V10.87c0-1.06-.48-2.06-1.3-2.7l-3.5-2.7a1.07 1.07 0 0 0-1.53.23c-.36.5-.26 1.2.22 1.58l1.3 1c.28.22.45.55.45.9V12c0 1.04.7 1.93 1.64 2.18.29.08.54.32.54.63V25.5a1.1 1.1 0 1 1-2.18 0v-1.13A3.34 3.34 0 0 0 20.36 21h-.54a.55.55 0 0 1-.55-.56V5.25c0-1.23-.99-2.25-2.18-2.25H6.2Zm.55 2.25h9.82c.3 0 .54.25.54.56v7.88c0 .3-.24.56-.54.56H6.73a.55.55 0 0 1-.55-.56V5.8c0-.3.25-.56.55-.56Z"
      />
    </BaseIcon>
  );
}
